import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { BemTipo } from "./bem-tipos.model";
import { apiName } from "./data.service";

@Injectable()
export class BemTiposApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: BemTipo, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: BemTipo, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    this._restService.onGetPostCustom(apiName + '/populado', {}, done);//busca bemTipos populado com subtipos
  }

  onGetById(objectId: number, done: any) {
    var object: any = {"id": objectId};//"body=%7B%22id%22%3A"+objectId+"%7D";
    this._restService.onGetPostCustom(apiName + '/populado', object, done); //busca o tipo de bem por id, com os subtipos populado
  }

  onGetByCategoria(categoriaId: number, done: any) {
    var object: any = {"categoriaId": categoriaId};//"body=%7B%22categoriaId%22%3A"+categoriaId+"%7D";
    this._restService.onGetPostCustom(apiName + '/populado', object, done); //busca os tipos de bens por categoria, populado com subtipos
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/shared/bem-tipos-api.service.ts
 **/